<template>
  <div class="form-group c-input-address">
    <label v-if="label" class="form__label" :for="slug">{{ label }}</label>
    <Address :value="text" @placechanged="onChange" :id="`${1}`"></Address>

    <InputError v-if="hasError" :message="errorMessage"></InputError>
    <InputDescription v-if="description" :message="description"></InputDescription>
  </div>
</template>

<script>
import InputError from "./input-error";
import InputDescription from "./input-description";
import slugify from "@swipekit/lib/slugify.js";
import Address from "./address";

export default {
  components: {
    InputError,
    InputDescription,
    Address,
  },

  data: function () {
    return {
      text: "",
    };
  },

  watch: {},

  props: {
    label: {
      type: String,
      default: "",
    },
    validation: {},
    value: {},
    placeholder: {
      type: String,
      default: "",
    },
    noStyle: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: "",
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {},
  },

  watch: {
    text: function () {
      this.$emit("input", this.text);
    },
    value: function () {
      this.setValue(this.value);
    },
  },

  computed: {
    slug: function () {
      return slugify(this.label || `input_${Math.floor(Math.random() * 100)}`);
    },
  },

  methods: {
    setValue: function (newValue) {
      if (!newValue) {
        return;
      }

      let currentValue = this.text;

      let value = newValue;

      let currentFlat = JSON.stringify(currentValue);

      let newFlat = JSON.stringify(value);

      if (currentFlat.length !== newFlat.length) {
        this.text = value;
      }
    },
    onChange: function (place) {
      this.text = place;
    },
  },

  mounted: function () {
    this.setValue(this.value);
  },
};
</script>

<style lang="scss">
.c-input-address {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: var(--margin-lg);
}
</style>
